import React, { Component } from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import {Provider} from './context';
import Navbar from './components/Layouts/Navbar';
import Main from './components/Layouts/Main';
import Lyrics from './components/Tracks/Lyrics';

export default class App extends Component {
  render() {
    return (
      <div>
        <Provider>
          <Router>
            <React.Fragment>
              <Navbar/>
                <div className="container">
                  <Switch>
                    <Route exact path="/" component={Main} />
                    <Route path="/lyrics/track/:id" component={Lyrics} />
                  </Switch>
                </div>
            </React.Fragment>
          </Router>
        </Provider>
      </div>
    )
  }
}
